import { ILocalTableData } from "@/interfaces/indicator";
import { getDetailTable } from "@/services/apis/modules/indicators";
import { useState, useEffect } from "react";

const useGetTableData = (key: string) => {
  const [tableData, setTableData] = useState<ILocalTableData>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTableData = async () => {
      setLoading(true);
      try {
        const response = await getDetailTable(key);
        setTableData(response);
      } catch (err) {
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchTableData();
  }, [key]);

  return { tableData, loading, error };
};

export default useGetTableData;